<template>
           
    <section id="servicios" class="secciones seccion-gris">        
      <div class="container">
        <h1>Armaq en Instagram</h1>
        <p>Revisa nuestras novedades y lo mas reciente en nuestro instagram.</p>
        <div class="row">
           <iframe src="https://ctppxztfz8.execute-api.us-west-2.amazonaws.com/v1/instagram/e495b8187e2f5dfd935d832375429686.html" scrolling="no" allowtransparency="true" class="lightwidget-widget" style="width:100%;border:0;overflow:hidden;"></iframe>
         </div>
         <a href="https://www.instagram.com/armasperu/" class="btn-al btn-al-lg btn-al-rojo-solid btn-secciones">Ver más</a> 
      </div>
                 
    </section>
</template>

<script src="https://cdn.lightwidget.com/widgets/lightwidget.js"></script>
<script>

export default {
  name: "Instagram",
  data() {
    return {
     
    };
  },
  methods: {

  //manadatory function called from cardTemplate 
    
  created() {
    
  }
}
}
</script>

<style>
.best-products {
  margin-bottom: 10px;
}

#cotizacion {
  padding: 0px;
}
</style>
